import React from 'react';
import { Routes, Route } from 'react-router-dom';
import SignIn from './SignIn';
import MainPage from './MainPage';
import RosaRApp from './RosaR/RosaRApp';
import RosaWApp from './RosaW/RosaWApp';

import Rosaa from './RosaA/Rosaa';
import Setupa from './RosaA/Setupa';
import Run from './RosaA/Run';
import SafetyOutline from './RosaA/SafetyOutline';


function App() {
  return (
    <Routes>
      <Route path="/" element={<SignIn />} />
      <Route path="/main" element={<MainPage />} />
     
      <Route path="/rosar" element={<RosaRApp />} />
      <Route path="/rosaw" element={<RosaWApp />} />

       <Route path="/rosaa" element={<Rosaa />} />
           <Route path="/setupa" element={<Setupa />} />
           <Route path="/run" element={<Run />} />
           <Route path="/safetyoutline" element={<SafetyOutline />} />


    </Routes>
  );
}

export default App;
